// Get the current targeting mode for UI display
function getTargetingMode(
  strategemTargetMode,
  immobilizeTargetMode, 
  confuseTargetMode,
  weaponTargetMode,
  deployTargetMode,
  selectedDeployOrderId,
  selectedDeployZone
) {
  if (strategemTargetMode) return 'strategem';
  if (immobilizeTargetMode) return 'immobilize';
  if (confuseTargetMode) return 'confuse';
  if (weaponTargetMode) return 'weapon';
  if (deployTargetMode && selectedDeployOrderId === 4 && selectedDeployZone === "front") return 'deploy';
  if (deployTargetMode && selectedDeployOrderId === 4 && selectedDeployZone === "flank") return 'deploy';
  if (deployTargetMode && selectedDeployOrderId) return 'deploy';
  return null;
}

export default getTargetingMode;
